<template>
  <div class="schedule-profile">
    <!-- <table class="table table-bordered">
        <thead>
            <tr>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-center">Thời gian</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 2</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 3</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 4</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 5</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 6</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Thứ 7</th>
                <th scope="col" class="color_bg_gray_light primary-color-txt text-right">Chủ nhật</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row" class="color_bg_gray_light primary-color-txt text-center">SÁNG</th>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
                    <td>@SÁNG</td>
            </tr>
            <tr>
                <th scope="row" class="color_bg_gray_light primary-color-txt text-center">CHIỀU</th>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
                    <td>@TRƯA</td>
            </tr>
            <tr>
                <th scope="row" class="color_bg_gray_light primary-color-txt text-center">TỐI</th>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
                    <td>@TỐI</td>
            </tr>
        </tbody>
    </table>-->
    <!-- {{getHomeTimeTable}} -->
    <p
      v-if="!displayEdit"
      class="d-flex justify-content-end mt-4 primary-color font-sanpro-semibold font-size-16 pointer__fullEditing"
      @click="fullEditing"
    >Chỉnh sửa</p>
    <p
      v-if="displayEdit"
      @click="deleteALLSchedule"
      class="d-flex justify-content-end mt-4 primary-color font-sanpro-semibold font-size-16 cursor-pointer"
    >Làm mới</p>
    <table :class="{table: displayEdit}">
      <tr class="day-in-week">
        <th scope="col" class="color_bg_gray_light primary-color-txt text-center time">Thời gian</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 2</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 3</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 4</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 5</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 6</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Thứ 7</th>
        <th scope="col" class="color_bg_gray_light primary-color-txt text-right day text-center">Chủ nhật</th>
      </tr>

      <tr  v-if="getHomeTimeTable && getHomeTimeTable.table" class="morning" v-for="(item,index) of getHomeTimeTable.table" :key="index">
        <th scope="row" class="color_bg_gray_light primary-color-txt text-center">{{item.vnName}}</th>
        <td v-for="(item1,index1) of item.dayOfWeeks" :key="index1">
          <!-- <draggable disabled v-model="item1.lessonClasses" ghost-class="ghost" @change="changeOnEnd"   @start="drag=false" v-if="displayEdit">
            <transition-group type="transition" name="flip-list">
              <div
                class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold btn_color_1 sortable d-flex justify-content-between"
                v-for="(item2,index2) of item1.lessonClasses"
                :key="item2.lessonClassId"
              >
                <strong>{{item2.name}}</strong>
                <div class="dislay__icon">
                  <a
                    class="edit_schedule"
                    @click="editSchedule(item2,index2)"
                    data-toggle="modal"
                    data-target=".modalAddSchedule"
                  >
                    <i class="far fa-edit"></i>
                  </a>
                  <a class="delete_schedule" @click="deleteSchedule(item2.lessonClassId)">
                    <i class="fas fa-times-circle color-err"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>-->
          <!-- <draggable disabled v-model="item1.lessonClasses" ghost-class="ghost" @change="changeOnEnd"   @start="drag=false" v-if="1=2"> -->
          <!-- <transition-group type="transition" name="flip-list"> -->
          <button
            class="form-control position-rel font-size-14 primary-color font-family-Semibold btn_color_1 detail_schedule d-flex justify-content-between"
            v-for="(item2,index2) of item1.lessonClasses"
            :key="item2.lessonClassId"
            @click="showModal (item2,index2)"
            data-toggle="modal"
            data-target=".modalAddScheduleDetail"
          >
            <strong>{{item2.name}}</strong>
          </button>

          <button
            v-if="displayEdit"
            @click="createLessonClass(item,item1)"
            class="form-control position-rel font-size-14 primary-color font-family-Semibold"
            data-toggle="modal"
            data-target=".modalAddSchedule"
          >
            <i class="fal fa-plus secondary-color-txt"></i>
          </button>
        </td>
        <!-- <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
        <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>-->
      </tr>
      <!-- <tr class="afternoon">
                <th scope="row" class="color_bg_gray_light primary-color-txt text-center">CHIỀU</th>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
            </tr>
            <tr class="night">
                <th scope="row" class="color_bg_gray_light primary-color-txt text-center">TỐI</th>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
                    <td><button class="form-control position-rel font-size-14 primary-color-txt font-family-Semibold" data-toggle="modal" data-target=".modalAddSchedule"><i class="fal fa-plus secondary-color-txt"></i></button></td>
      </tr>-->
    </table>
    <div class="d-flex justify-content-end complete_sum mb-5" v-if="displayEdit"> 
      <button type="button" class="font-size-16 exit" @click="exitshedule">Hủy</button>
      <button
        data-dismiss="modal"
        type="button"
        class="btn btn-main border-rd-20 font-size-16 font-sanpro-semibold p-b p-t"
        @click="completeSum"
      >Hoàn thành</button>
    </div>
    <b-modal id="modalAddSchedule" class="ScheduleProfile">
      <!-- <div class="modal-dialog" role="document"> -->
      <!-- <div class="modal-content"> -->
      <b-form @submit="onSubmit">
        <div class="modal-content__top d-flex justify-content-between">
            <!-- v-if="checkForm" -->
          <h5
          
            class="modal-title text-center font-size-25 title-color-gray font-sanpro-semibold"
            id="exampleModalLabel"
          >Tiết học</h5>
        </div>
        <div class="modal-content__mid title-color-gray  font-size-16">
          <p>{{dayOfWeekName}} - {{timeOfDayName}}</p>
          <label for>Môn học</label>
          <div class="form-group" style="width:100%;">
            <input
              type="text"
              class="form-control"
              placeholder="Nhập tên môn học vào đây"
              v-model="nameLessonClasses"
            />
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label for>Giờ bắt đầu</label>
              <div class="form-group" style="width:100%;">
                <div style="position:relative">
                  <date-picker
                    v-model="timeBegin"
                    type="time"
                    placeholder="00 : 00"
                    format="HH:mm"
                    value-type="format"
                   
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <label for>Giờ kết thúc </label>
              <div class="form-group" style="width:100%;">
                <div style="position:relative">
                  <!-- <date-picker
                      required
                      v-model="time2"
                      value-type="format"
                      format="HH"
                      placeholder="dd / mm / yyyy"
                  ></date-picker>-->
                  <!-- <date-picker v-model="timeEnd" type="time" placeholder="Select time" :default-value="new Date().setHours(9, 0, 0)"    :disabled-date="notBeforeNine"  format="HH:mm"></date-picker> -->
                  <date-picker
                    v-model="timeEnd"
                    value-type="format"
                    format="HH:mm"
                    type="time"
                    placeholder="00 : 00"
                    :disabled-time="notBeforeNine"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content__bot text-right d-flex  " :class="{justifycontentend : lessonClassId ==0 ,justifycontentbetween: lessonClassId!=0}">
          <span v-if=" lessonClassId !=0" class="four-color" @click="deleteSchedule(lessonClassId)">Xóa</span>
          <div >
            <button type="button" class="font-size-16 exit" @click="exitModal">Hủy</button>
            <button
              data-dismiss="modal"
              type="submit"
              class="btn btn-primary font-size-16 access"
              :class="{'disabled': !nameLessonClasses || nameLessonClasses==''}"
            >Hoàn thành</button>
          </div>
        </div>
        <!-- </div> -->
        <!-- </div> -->
      </b-form>
    </b-modal>
    <!-- ..... -->
    <div
      class="modal fade"
      :class="{modalAddScheduleDetail : !displayEdit}"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalAddSchedule"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-content__top d-flex justify-content-between">
            <h5
              class="modal-title text-center font-size-25"
              id="exampleModalLabel"
            >{{nameLessonClasses}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fas fa-times-circle font-size-16"></i>
            </button>
          </div>
          <div class="modal-content__mid">
            <p class="mb-4">{{dayOfWeekName}} - {{timeOfDayName}}</p>
            <div class="row">
              <div class="col-lg-6">
                <label for>Giờ Bắt đầu</label>
                <input type="text"  placeholder="00 : 00" v-model="timeBegin" disabled />
              </div>
              <div class="col-lg-6">
                <label for>Giờ kết thúc</label>
                <input type="text"  placeholder="00 : 00" v-model="timeEnd" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const today = new Date();
today.setHours(0, 0, 0, 0);
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import debounce from "@/directives/debounce";
import { createLessonClass } from "../../_api";
import { updateLessonClass } from "../../_api";
import { deleteLessonClass,apiDeleteAllSchedule } from "../../_api";

import Pagination from "@/components/Pagination.vue";
import moment from "moment";
import draggable from "vuedraggable";
export default {
  name: "ScheduleProfile",
  components: {
    draggable,
    DatePicker
  },
  data() {
    return {
      lessonClassId: 0,
      oldIndex: "",
      newIndex: "",
      dayOfWeekIdCreate: 0,
      timeOfDayIdCreate: 0,
      nameLessonClasses: "",
      checkForm: true,
      dayOfWeekIdUpdate: 0,
      timeOfDayIdupdate: 0,
      orderNo: 0,
      displayEdit: false,
      timeBegin: "",
      timeEnd: "",
      formatDate1: "hh:mm",
      timeOfDayName:'',
      dayOfWeekName:'',
    };
  },
  mounted() {
    this.actionHomeGetTimeTable();
  },
  computed: {
    ...mapGetters({
      getHomeTimeTable: STORE_KEY + "/getHomeTimeTable"
    })
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "actionHomeGetTimeTable",
      "actionUpdateLessonClass"
    ]),
    moment,
    ...mapActions(`common`, ["setLoading"]),
    deleteALLSchedule(){
      let values ={}
      values.UserId =0;
      apiDeleteAllSchedule(values).then(res => {
        if (res.status === "success") {
          this.actionHomeGetTimeTable();
          this.$toast.success("Làm mới thành công");
        }
      });
    },
    notBeforeNine(date) {
      var arrytimeBegin = this.timeBegin.split(":") ;
      var timeBeginInt = parseInt([arrytimeBegin[0]])
      return date.getHours() < timeBeginInt
    },
    notBeforeNinebegin(){

    },
    exitModal(){
       this.$bvModal.hide("modalAddSchedule");
    },
    showModal(item2, index2) {
        var dataTimeOfDayId = this.getHomeTimeTable.table.find(
        element => element.timeOfDayId == item2.timeOfDayId
        );
        this.timeOfDayName = dataTimeOfDayId.vnName;
        var datadayOfWeekId = dataTimeOfDayId.dayOfWeeks.find(
        element => element.dayOfWeekId == item2.dayOfWeekId
        );
        this.dayOfWeekName = datadayOfWeekId.vnName;
        this.lessonClassId = item2.lessonClassId;
        this.checkForm = false;
        this.dayOfWeekIdCreate = item2.dayOfWeekId;
        this.timeOfDayIdCreate = item2.timeOfDayId;
        this.nameLessonClasses = item2.name;
        this.timeBegin = item2.timeBegin;
        this.timeEnd =  item2.timeEnd;
        this.orderNo = index2;
        //console.log("@2222222222  this.timeBegin",  this.timeBegin, this.timeEnd);
        
      if (this.displayEdit) {
          this.$bvModal.show("modalAddSchedule");
      }
    },

    fullEditing() {
      this.displayEdit = true;
    },
    changeOnEnd(evt) {
      this.oldIndex = evt.moved.oldIndex;
      this.newIndex = evt.moved.newIndex;
      var dataTimeOfDayId = this.getHomeTimeTable.table.find(
        element => element.timeOfDayId == evt.moved.element.timeOfDayId
      );
      var dataDayOfWeekId = dataTimeOfDayId.dayOfWeeks.find(
        element => element.dayOfWeekId == evt.moved.element.dayOfWeekId
      );
      dataDayOfWeekId.lessonClasses.forEach((value, index1) => {
        var data = {};
        data["lessonClassId"] = value.lessonClassId;
        data["name"] = value.name;
        data["orderNo"] = index1;
        data["dayOfWeekId"] = value.dayOfWeekId;
        data["timeOfDayId"] = value.timeOfDayId;
        this.actionUpdateLessonClass(data);
      });
    },
    createLessonClass(item, item1) {
        this.lessonClassId = 0;
        this.nameLessonClasses = "" ;
        this.timeBegin ="";
        this.timeEnd ="";
        var dataTimeOfDayId = this.getHomeTimeTable.table.find(
        element => element.timeOfDayId == item.timeOfDayId
        );
        this.timeOfDayName = dataTimeOfDayId.vnName;
        var datadayOfWeekId = dataTimeOfDayId.dayOfWeeks.find(
        element => element.dayOfWeekId == item1.dayOfWeekId
        );
        this.dayOfWeekName = datadayOfWeekId.vnName;
      this.$bvModal.show("modalAddSchedule");

      this.dayOfWeekIdCreate = item1.dayOfWeekId;
      this.timeOfDayIdCreate = item.timeOfDayId;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.lessonClassId == 0) {
        let data = {};
        data["lessonClassId"] = 0;
        data["name"] = this.nameLessonClasses;
        data["dayOfWeekId"] = this.dayOfWeekIdCreate;
        data["timeOfDayId"] = this.timeOfDayIdCreate;
        data["timeBegin"] =this.timeBegin;
        data["timeEnd"] = this.timeEnd;
        createLessonClass(data).then(res => {
          if (res.status === "success") {
            this.nameLessonClasses = "";
            this.actionHomeGetTimeTable();
            this.$bvModal.hide("modalAddSchedule");
            this.$toast.success("Thêm thành công");
          }
        });
      } else {
        let data = {};
        data["lessonClassId"] = this.lessonClassId;
        data["orderNo"] = this.orderNo;
        data["name"] = this.nameLessonClasses;
        data["dayOfWeekId"] = this.dayOfWeekIdCreate;
        data["timeOfDayId"] = this.timeOfDayIdCreate;
        data["timeBegin"] =this.timeBegin;
        data["timeEnd"] = this.timeEnd;
        this.actionUpdateLessonClass(data).then(res => {
          if (res.status === "success") {
            this.nameLessonClasses = "";
            this.actionHomeGetTimeTable();
            this.$bvModal.hide("modalAddSchedule");
            this.$toast.success("Sửa thành công");
            this.lessonClassId = 0;
            this.orderNo = 0;
            this.nameLessonClasses = "";
            this.dayOfWeekIdCreate = 0;
            this.timeOfDayIdCreate = 0;
          }
        });
      }
    },
    editSchedule(item2, index2) {
      this.lessonClassId = item2.lessonClassId;
      this.checkForm = false;
      this.dayOfWeekIdCreate = item2.dayOfWeekId;
      this.timeOfDayIdCreate = item2.timeOfDayId;
      this.nameLessonClasses = item2.name;
      this.orderNo = index2;
    },
    deleteSchedule(id) {
      deleteLessonClass({ Id: id }).then(res => {
        if (res.status === "success") {
          this.actionHomeGetTimeTable();
          this.$toast.success("Xóa thành công");
          this.$bvModal.hide("modalAddSchedule");
        }
      });
    },
    exitshedule(){
      this.displayEdit = false
    },
    completeSum(){
      this.displayEdit = false
    }
  }
};
</script>

<style lang="scss" scoped>
.cursor-pointer{
  cursor: pointer;
}
.table{
  margin: 20px 0 30px 0 !important;
}
.complete_sum{
  .exit {
      background: #fff;
      color: #124abe;
      border: 0;
  }
  button {
      height: 30px;
      line-height: 15px;
      border-radius: 20px;
  }
}
.pointer__fullEditing {
  cursor: pointer;
}
.edit_schedule {
  cursor: pointer;
}
.delete_schedule {
  cursor: pointer;
}
.dislay__icon {
  display: none;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
table,
td,
th {
  border: 1px solid #879aa9;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0 100px 0;

  .day-in-week {
    .time {
      width: 180px;
    }
    .day {
      padding-right: 10px;
      width: 164px;
    }
  }
  .morning,
  .afternoon,
  .night {
    td {
      padding: 10px 12px;
      height: 172px;

      .ghost {
        border-left: 6px solid rgb(0, 183, 255) !important;
        //   box-shadow: 10px 10px 5px -1px red;
        opacity: 0.7;
      }
      .sortable {
        height: 25px;
        background: #f3f6fb;
        line-height: 10px;
        border: 0;
        border-radius: 8px;
        margin-bottom: 6px;
        cursor: move;
      }
      .sortable:hover {
        .dislay__icon {
          display: block;
        }
      }
      button {
        height: 25px;
        background: #f3f6fb;
        line-height: 10px;
        border: 0;
        border-radius: 8px;
        margin-bottom: 6px;
        strong{
          width: 100%;
        }
      }
      button:last-child {
        margin-bottom: 0px;
      }
      button:hover {
        background: #e1efff;
        i {
          color: #124abe;
        }
      }
    }
  }
}
th {
  height: 37px;
}
#modalAddSchedule {
  .modal-content__mid {
    input {
      background-color: #f3f6fb;
      border: 0;
      border-radius: 20px;
      padding-left: 15px;
      height: 32px;
      line-height: 32px;
      width: 100%;
    }
  }
  .modal-content__bot {
    cursor: pointer;
    margin-top: 50px;
    button {
      height: 30px;
      // line-height: 15px;
      border-radius: 20px;
      left:300px;
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .exit {
      background: #fff;
      color: #124abe;
      border: 0;
    }
    .access {
      background: #124abe;
      color: #fff;
    }
  }
  // }
}
.modalAddScheduleDetail {
  .modal-content {
    padding: 30px;
    &__top {
      margin-bottom: 20px;
      button {
        position: absolute;
        top: 10px;
        right: 20px;
        i {
          color: #fd6c6f;
        }
      }
    }
    &__mid {
      input {
        background-color: #f3f6fb;
        border: 0;
        border-radius: 20px;
        padding-left: 15px;
        height: 32px;
        line-height: 32px;
        width: 100%;
      }
    }
    &__bot {
      margin-top: 50px;
      button {
        height: 30px;
        line-height: 15px;
        border-radius: 20px;
      }
      .exit {
        background: #fff;
        color: #124abe;
        border: 0;
      }
      .access {
        background: #124abe;
        color: #fff;
      }
    }
  }
}
</style>